(function () {
  'use strict';

  /* Guard against the script being evaluated twice (theme editor section reloads). */
  if (window.__ceContactLoaded) return;
  window.__ceContactLoaded = true;

  var teardown = null;
  var ROOT_ID = 'contact-editorial';

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

  function init(root) {
    if (!root || root.dataset.ceReady) return;
    root.dataset.ceReady = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var wide = window.matchMedia('(min-width: 990px)');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ce-reveal'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-ce-depth]'));
    var panel = root.querySelector('.ce-panel');
    var io = null;
    var ticking = false;

    function reveal(el) {
      el.classList.add('ce-in');
      window.setTimeout(function () { el.style.transitionDelay = '0s'; }, 1800);
    }
    function showAll() {
      items.forEach(function (el) { el.classList.add('ce-in'); el.style.transitionDelay = '0s'; });
    }

    /* Scroll reveals. Hidden states only exist once .ce-js is set. */
    function startReveals() {
      if (io || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top > 0) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { if (!el.classList.contains('ce-in')) io.observe(el); });
    }

    /* Scroll-linked movement: a soft depth shift (lighter on small screens) and a background that warms from cream to paper as the form comes into view. */
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      var scale = wide.matches ? 1 : 0.4;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > vh + 300) return;
        var factor = parseFloat(el.getAttribute('data-ce-depth')) || 0;
        var offset = (rect.top + rect.height / 2 - vh / 2) * factor * scale;
        el.style.setProperty('--ce-shift', clamp(offset, -30 * scale, 30 * scale).toFixed(1) + 'px');
      });
      if (panel) {
        var r = panel.getBoundingClientRect();
        var p = clamp((vh * 0.9 - r.top) / (vh * 0.7), 0, 1);
        root.style.setProperty('--ce-p', p.toFixed(3));
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function bindScroll() {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    function unbindScroll() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      layers.forEach(function (el) { el.style.removeProperty('--ce-shift'); });
      root.style.removeProperty('--ce-p');
    }

    function applyMode() {
      if (reduced.matches) {
        if (io) { io.disconnect(); io = null; }
        unbindScroll();
        showAll();
      } else {
        startReveals();
        unbindScroll();
        bindScroll();
      }
    }

    root.classList.add('ce-js');
    if (!('IntersectionObserver' in window)) showAll();
    applyMode();

    function listen(query, handler) {
      if (query.addEventListener) query.addEventListener('change', handler);
      else if (query.addListener) query.addListener(handler);
    }
    function unlisten(query, handler) {
      if (query.removeEventListener) query.removeEventListener('change', handler);
      else if (query.removeListener) query.removeListener(handler);
    }
    listen(reduced, applyMode);
    listen(wide, applyMode);

    /* Touch devices only apply :active once a touch listener exists (iOS Safari). */
    function noop() {}
    root.addEventListener('touchstart', noop, { passive: true });

    teardown = function () {
      if (io) io.disconnect();
      unbindScroll();
      unlisten(reduced, applyMode);
      unlisten(wide, applyMode);
      root.removeEventListener('touchstart', noop);
      root.classList.remove('ce-js');
      delete root.dataset.ceReady;
      teardown = null;
    };
  }

  function ours(event) {
    var t = event && event.target;
    return !t || !t.querySelector || t.id === ROOT_ID || !!t.querySelector('#' + ROOT_ID);
  }
  function scan(event) {
    if (!ours(event)) return;
    if (teardown) teardown();
    init(document.getElementById(ROOT_ID));
  }
  function release(event) {
    if (ours(event) && teardown) teardown();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', release);
})();
